'use client';

import { PageContainer } from '@/components/Page/PageContainer';
import { PageError } from '@/components/Page/PageError';
import { StackedLayout } from '@/components/StackedLayout';
import { Footer } from '@/components/Footer';

export default function SplatPage() {
  return (
    <StackedLayout footer={<Footer />}>
      <PageContainer>
        <PageError
          heading="This Page Could Not Be Found"
          helpText="The link may be broken, or the page may have moved."
        />
      </PageContainer>
    </StackedLayout>
  );
}
